import { render } from "./two-factor-auth.vue?vue&type=template&id=29917afe&scoped=true"
import script from "./two-factor-auth.vue?vue&type=script&lang=js"
export * from "./two-factor-auth.vue?vue&type=script&lang=js"

import "./two-factor-auth.vue?vue&type=style&index=0&id=29917afe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29917afe"]])

export default __exports__